<p-dialog
  #dialogInfoGrid
  [modal]="true"
  [visible]="true"
  (visibleChange)="dialogRef.close()"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
  [maximizable]="true"
  [closable]="true"
  [responsive]="true"
  [closeOnEscape]="false"
  [dismissableMask]="false"
>
  <ng-template pTemplate="header">
    <h1 mat-dialog-title>
      <i [class]="data.icon ?? 'pi pi-fw pi-cog text-primary'"></i>
      {{ titulo }}
    </h1>
  </ng-template>
  <div class="row mt-2 flex align-items-center justify-content-center">
    <div class="col-md-5 cursor-pointer">
      <mat-form-field
        class="width-100 cursor-pointer"
        appearance="outline"
        [matMenuTriggerFor]="menuAnoMes"
      >
        <mat-label>Ano/Mês</mat-label>
        <input
          matInput
          [formControl]="keywordAnoMes"
          (keyup)="enterSearch($event)"
          readonly
          class="cursor-pointer"
        />
        <i
          matSuffix
          id="search-keyword"
          class="text-primary pi pi-fw pi-search cursor-pointer mr-2"
        >
        </i>
      </mat-form-field>
      <small class="p-error" *ngIf="keywordAnoMes.invalid">
        Obrigatório informar!
      </small>

      <mat-menu
        #menuAnoMes="matMenu"
        (close)="!keywordAnoMes.value ? removerSelecaoAnoMes() : null"
        [ngClass]="{ 'mat-menu-panel-no-padding': true }"
      >
        <p-calendar
          *ngIf="!showMes"
          (click)="$event.stopPropagation()"
          [formControl]="keywordFormInputAno"
          view="year"
          [inline]="true"
          [maxDate]="today"
        ></p-calendar>

        <p-calendar
          *ngIf="showMes"
          (click)="$event.stopPropagation()"
          [formControl]="keywordFormInputMes"
          view="month"
          [ngClass]="{ 'hidden-prev-next-btn': true }"
          [inline]="true"
          [maxDate]="today"
        ></p-calendar>
        <div
          class="flex align-items-center justify-content-between width-100 mt-2"
        >
          <button
            pButton
            pRipple
            text
            severity="danger"
            rounded
            [label]="showMes ? 'Anterior' : 'Cancelar'"
            (click)="showMes ? $event.stopPropagation() : null"
            icon="pi pi-fw pi-times-circle"
            [icon]="
              showMes ? 'pi pi-fw pi-chevron-left' : 'pi pi-fw pi-times-circle'
            "
            (click)="showMes ? removerSelecaoMes() : removerSelecaoAnoMes()"
            class="p-button-sm"
          ></button>
          <button
            pButton
            pRipple
            text
            rounded
            (click)="showMes ? null : $event.stopPropagation()"
            severity="primary"
            [disabled]="
              showMes
                ? !keywordFormInputAno.value || !keywordFormInputMes.value
                : !keywordFormInputAno.value
            "
            (click)="showMes ? confirmarSelecaoAnoMes() : selecionarIrPraProx()"
            [label]="showMes ? 'Selecionar' : 'Próximo'"
            [icon]="
              showMes ? 'pi pi-fw pi-check-circle' : 'pi pi-fw pi-chevron-right'
            "
            class="p-button-sm"
            iconPos="right"
          ></button>
        </div>
      </mat-menu>
    </div>
    <button
      pButton
      pRipple
      icon="pi pi-fw pi-print"
      severity="primary"
      rounded
      text
      [disabled]="!keywordAnoMes.value || filterEntities.length === 0"
      (click)="gerarRelatorio()"
    ></button>
  </div>
  <viggo-core-grid-table
    #table
    [ngClass]="{ 'table-info-grid': true }"
    [showPaginator]="true"
    [loading]="loading"
    [showReorderColumns]="false"
    [showExportData]="false"
    [showImportData]="false"
    [showErrorMessage]="errorResponse"
    [errorMessage]="getMessageError()"
    [errorTitle]="errorResponse?.title"
    [data]="filterEntities"
    [columnDefs]="columnDefs"
    [noResults]="noResults"
    [menu]="entityName"
    [KEY_PAGINATOR_SIZE_LOCALSTORAGE]="KEY_PAGINATOR_DIALOG_MOV_PARTICIPANTE"
    [moduleName]="entityName.toUpperCase() + '_DIALOG_GRID'"
    [KEY_DATA_SELECTION]="KEY_DATA_SELECTION"
    [KEY_DATA_NOT_SELECTION]="KEY_DATA_NOT_SELECTION"
    [KEY_DATA_ALL_SELECTED]="KEY_DATA_ALL_SELECTED"
    [paginatorPageIndex]="page"
    [showPaginator]="true"
    [first]="getFirstConfigPagination()"
    [pageLength]="pageLength"
    [disableCheckbox]="true"
    (onHandlePage)="handlePage($event)"
    [showLegendFooter]="true"
    [legendFooter]="getFooterInfo()"
  ></viggo-core-grid-table>
</p-dialog>
